import React from "react";
import { AppBar, Box, List, ListItemButton, Toolbar } from "@mui/material";
import { Capacitor } from "@capacitor/core";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { NAVIGATION } from "../../../locales/components/namespaces";
import { getRouteUrl } from "../../../helpers/getRouteUrl";
import { ROUTE_PAGE_UNAUTHORIZED_CALCULATION } from "../../../routers/routes";
import Localization from "../../../theme/mantis/layout/mainLayout/header/headerContent/localization";
import NavItem from "../../../theme/mantis/layout/mainLayout/drawer/drawerContent/navigation/navItem";
import LogoHeadIcon from "../../../assets/images/icons/menuIcons/logoHeadIcon";
import CalculatorBlueIcon from "../../../assets/images/icons/menuIcons/calculatorBlueIcon";
import CalcActive from "../../../assets/images/icons/calcActive";
import HeadphonesBlueIcon from "../../../assets/images/icons/menuIcons/headphonesBlueIcon";
import ContactActive from "../../../assets/images/icons/contactActive";
import SupportDialog from "../../../pages/supportDialog/supportDialog";

// Header for fast-login (otp) users: app-style header without
// profile / session timer / notifications — only the calculator
// item that is accessible without login
const HeaderFastLogin = () => {
  const { t } = useTranslation(NAVIGATION);
  const [supportOpen, setSupportOpen] = useState(false);

  const calculatorItem = {
    url: getRouteUrl(ROUTE_PAGE_UNAUTHORIZED_CALCULATION),
    title: t("Loan calculator"),
    icon: CalculatorBlueIcon,
    hoverIcon: CalcActive,
    hoverMessage: t("Loan calculator"),
    id: "loan-calculation",
    type: "item",
    breadcrumbs: false,
  };

  const supportItem = {
    url: "",
    title: t("Support"),
    icon: HeadphonesBlueIcon,
    hoverIcon: ContactActive,
    hoverMessage: t("Support"),
    id: "support",
    type: "item",
    breadcrumbs: false,
    support: true,
  };

  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{ zIndex: 1200, width: '100%', backgroundColor: 'primary.main' }}
    >
      <Toolbar
        sx={{
          backgroundColor: 'white',
          margin: { xs: '5px', sm: '5px', md: '16px', lg: '16px' },
          borderRadius: '12px',
          border: '0.6px solid #DAE0F0',
          paddingX: '10px !important',
          paddingBottom: '10px !important',
          paddingTop: Capacitor.isNativePlatform() ? 3.2 : '10px !important',
        }}
      >
        <ListItemButton
          sx={{ paddingLeft: '0 !important', '&:hover': { backgroundColor: 'transparent' }, flexGrow: 'initial !important' }}
        >
          <LogoHeadIcon />
        </ListItemButton>
        <Box sx={{ margin: '0 auto', display: 'block' }}>
          <List sx={{ display: 'flex', p: 0, m: 0 }}>
            <NavItem item={calculatorItem} />
            <NavItem item={supportItem} onClickAction={() => setSupportOpen(true)} />
          </List>
        </Box>
        <Box
          className="flex-center-right"
          sx={{ margin: { xs: 'auto 0 0 auto', sm: 'auto 0 0 auto', md: '0 0 0 28px' }, '& .MuiBox-root': { margin: '0 !important' } }}
        >
          <Localization />
        </Box>
      </Toolbar>
      <SupportDialog
        selectedValue={null}
        open={supportOpen}
        onClose={() => setSupportOpen(false)}
      />
    </AppBar>
  );
};

export default HeaderFastLogin;
